import { put, take, takeEvery } from 'redux-saga/effects';
import { RulesetSplitTest } from 'entities/rulesetSplitTest';
import { GenericAction as RestAPIAction, Types as RestAPITypes } from 'services/genericAPIGatewayService';
import { Service } from '../services';
import { Actions } from './rest';

export enum SplitTestTypes {
  Update = 'UPDATE_RULESET_SPLITTEST',
}

export interface UpdateAction {
  type: SplitTestTypes.Update;
  id: string;
  oldSplitTest: RulesetSplitTest;
  newSplitTest: RulesetSplitTest;
}

export const updateRulesetSplitTest = (
  id: string,
  oldSplitTest: RulesetSplitTest,
  newSplitTest: RulesetSplitTest,
): UpdateAction => ({
  type: SplitTestTypes.Update,
  oldSplitTest,
  newSplitTest,
  id,
});

const getUrlParams = (splitTest: RulesetSplitTest): { campaignId: string; rulesetId: string } => ({
  campaignId: splitTest.campaignId,
  rulesetId: splitTest.rulesetId,
});

function* update(updateRulesetAction: UpdateAction) {
  yield put(
    Actions.requestUpdate(
      updateRulesetAction.id,
      updateRulesetAction.newSplitTest,
      getUrlParams(updateRulesetAction.newSplitTest),
    ),
  );
}

function* moveAndUpdate(updateRulesetAction: UpdateAction) {
  yield put(Actions.requestDelete(updateRulesetAction.id, getUrlParams(updateRulesetAction.oldSplitTest)));

  yield take(
    (action: RestAPIAction<any, any>) =>
      (action.type === RestAPITypes.DELETE_COMPLETED || action.type === RestAPITypes.DELETE_FAILED) &&
      action.payload.id === updateRulesetAction.id &&
      action.service === Service.RulesetSplitTests,
  );

  yield update(updateRulesetAction);
}

export function* updateSplitTest(action: UpdateAction) {
  if (
    action.newSplitTest.campaignId === action.oldSplitTest.campaignId &&
    action.newSplitTest.rulesetId === action.oldSplitTest.rulesetId
  ) {
    yield update(action);
  } else {
    yield moveAndUpdate(action);
  }
}

function* watchForUpdateSplitTest() {
  yield takeEvery(SplitTestTypes.Update, updateSplitTest);
}

export const Sagas = [watchForUpdateSplitTest];
